import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "./firebaseConfig";

import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import MisProductos from "./pages/MisProductos";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import DeleteAccountInfo from "./pages/DeleteAccountInfo";
import Support from "./pages/Support";
import ProductoFormPage from "./pages/ProductoFormPage";
import MisVentas from "./pages/MisVentas";
import DetalleVenta from "./pages/DetalleVenta";

import StripeOnboardingDone from "./pages/StripeOnboardingDone";
import MyShopCityLanding from "./pages/MyShopCityLanding";
import CrearCuentaWeb from "./pages/auth/CrearCuentaWeb";
import CrearAnuncioGeneralPage from "./pages/CrearAnuncioGeneralPage";



function App() {
  const [user, setUser] = useState(undefined); // undefined=cargando, null=no logueado

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });
    return () => unsub();
  }, []);

  if (user === undefined) return <p>Cargando...</p>;

  return (
    <BrowserRouter>
      <Routes>
        {/* 🔓 RUTAS PÚBLICAS */}
        <Route path="/" element={<MyShopCityLanding user={user} />} />
        <Route path="/myshopcity-landing" element={<MyShopCityLanding user={user} />} />

        <Route path="/login" element={<Login onLogin={setUser} />} />
        <Route path="/crear-cuenta" element={<CrearCuentaWeb />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/delete-account" element={<DeleteAccountInfo />} />
        <Route path="/support" element={<Support />} />
        <Route path="/stripe/ok" element={<StripeOnboardingDone />} />

         {/* 🔓 RUTAS PÚBLICAS PARA DIRIGIR A LA APP */}
        <Route path="/producto/:id" element={<MyShopCityLanding user={user} />} />
        <Route path="/anuncio/:id" element={<MyShopCityLanding user={user} />} />
        <Route path="/post/:id" element={<MyShopCityLanding user={user} />} />
        <Route path="/perfil/:id" element={<MyShopCityLanding user={user} />} />

        {/* 🔐 ZONA PRIVADA (solo requiere login) */}
        <Route element={user ? <Layout /> : <Navigate to="/login" replace />}>
          {/* Mantengo /admin como dashboard como pediste */}
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/misProductos" element={<MisProductos />} />
          <Route path="/anuncioGeneral" element={<CrearAnuncioGeneralPage />} />

          
          <Route path="/misVentas" element={<MisVentas />} />
          <Route path="/ventas/:idventa" element={<DetalleVenta />} />
          <Route path="/admin/productos/nuevo" element={<ProductoFormPage />} />
          <Route path="/admin/productos/editar/:productId" element={<ProductoFormPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;